export default __webpack_public_path__ + "static/mobile_16-a4e3ca6a40d92da68ef94d407603e876.webp";